import { Button, Header, Layout } from '@kanda-libs/ks-design-library';
import useHelpModal from 'components/HelpModal/useHelpModal';
import { URLS } from 'config';
import type { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import type { HomeLayoutProps } from '.';

const HomeLayoutMobile: FunctionComponent<HomeLayoutProps> = function ({
  children,
}) {
  const { showHelpModal } = useHelpModal();
  return (
    <Layout
      stickyFooter
      noBorder
      stickyHeader
      header={
        <Header.Main
          linkComponent={Link}
          help={(e) => {
            if (e && typeof e.stopPropagation === 'function') {
              e.stopPropagation();
            }
            showHelpModal();
          }}
          hideNumber
        />
      }
      footer={
        <div className="flex w-full">
          <Link to={URLS.jobs} className="ml-auto">
            <Button.Text
              id="home-go-to-jobs"
              label="Go To Jobs"
              icon="arrow-right"
              variant="gradient"
            />
          </Link>
        </div>
      }
    >
      <div className="z-0">{children}</div>
    </Layout>
  );
};

export default HomeLayoutMobile;
